import styled from 'styled-components';
import {
  BREAKPOINT,
  PADDING,
  REBRAND_COLOR,
  MARGIN
} from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const Wrapper = styled.div`
    background: ${({ background }) =>
    background ? background : `${REBRAND_COLOR.WHITE}`};
`;

export const StyledPromoBannerContainer = styled(Section)`
  width: 100%;
  display: flex;
  flex-direction: ${({ isReversed }) =>
      isReversed ? 'column-reverse' : 'column'};
  margin-top: ${MARGIN.M32};

  @media (min-width: ${BREAKPOINT.MD}) {
    flex-direction: ${({ isReversed }) =>
      isReversed ? 'row-reverse' : 'row'};
    justify-content: center;
    align-items: center;
    gap: 32px;
    margin-top: 0;
  }
`;

export const StyledTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center; /* center text vertically */
  align-items: flex-start;
  gap: 16px;
  padding-top: ${PADDING.P32};
  padding-bottom: ${PADDING.P32};
  u {
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
  @media (min-width: ${BREAKPOINT.MD}) {
    width: ${({ fullWidth }) =>
      fullWidth ? '100%' : '35%'};
    padding-top: ${PADDING.P64};
    padding-bottom: ${PADDING.P64};
  }
`;

export const StyledImageContainer = styled.div`
width: ${({ fullWidth }) =>
      fullWidth ? '100%' : 'auto'};
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    @media (min-width: ${BREAKPOINT.MD}) {
      aspect-ratio: ${({ fullWidth }) =>
      fullWidth ? '371 / 250' : '325 / 273'};
      height: ${({ fullWidth }) =>
      fullWidth ? '250px' : '273px'};
      object-fit: contain;
      width: auto;
    }
  }
`;
